import { Pipe, PipeTransform } from '@angular/core';

import * as day from 'dayjs';

@Pipe({
  name: 'dayjs',
})
export class DayJsPipe implements PipeTransform {
  transform(date: day.Dayjs, format: string): string {
    return date.format(format);
  }
}
